import React from 'react';
import { Select } from 'antd';
import { MdSort, MdFilterListOff } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { sortOptions } from '../mysearchConstants';

interface SearchHeaderProps {
  total: number;
  sortBy: string;
  activeFilterCount: number;
  hasActiveSearch?: boolean;
  onSortChange: (val: string) => void;
  onReset: () => void;
}

const SearchHeader: React.FC<SearchHeaderProps> = ({
  total,
  sortBy,
  activeFilterCount,
  hasActiveSearch,
  onSortChange,
  onReset,
}) => {
  const { t } = useTranslation();
  const sortLabelMap: Record<string, string> = {
    standard: `✦ ${t('search_results.smart_ranking')}`,
    price_asc: t('search_results.price_low_high'),
    price_desc: t('search_results.price_high_low'),
    year_desc: t('search_results.newest_first'),
    mileage_asc: t('search_results.lowest_mileage'),
    mileage_desc: t('search_results.highest_mileage'),
  };
  return (
    <div className="sh-root">
      <div className="sh-left">
        <span className="sh-count">{total.toLocaleString('de-DE')}</span>
        <span className="sh-label">{t('search_results.vehicles_found', { count: total })}</span>
        {(activeFilterCount > 0 || hasActiveSearch) && (
          <button className="sh-clear" onClick={onReset}>
            <MdFilterListOff size={14} /> {t('filters.clear_all')} {activeFilterCount > 0 && `(${activeFilterCount})`}
          </button>
        )}
      </div>
      <div className="sh-right">
        <MdSort size={18} style={{ color: '#888' }} />
        <Select
          value={sortBy}
          onChange={onSortChange}
          className="sh-sort"
          options={sortOptions.map(s => ({ value: s.value, label: sortLabelMap[s.value] || s.label }))}
          style={{ width: 200 }}
        />
      </div>
    </div>
  );
};

export default SearchHeader;
